import { createContext, useContext } from "react";

export const RedesignContext = createContext({
    enabled: false,
});

/** Presentation only: the project's Design v2 flag, unless this browser chose for itself. */
export function useRedesign() {
    return useContext(RedesignContext);
}
